import { render, staticRenderFns } from "./NoPrizeModal.vue?vue&type=template&id=b9d46358&scoped=true"
import script from "./NoPrizeModal.vue?vue&type=script&lang=js"
export * from "./NoPrizeModal.vue?vue&type=script&lang=js"
import style0 from "./NoPrizeModal.vue?vue&type=style&index=0&id=b9d46358&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d46358",
  null
  
)

export default component.exports